export const handleError = async (
  errorCode: string,
  message = 'IndexedDBのアクセスに失敗しました。'
): Promise<never> => {
  return await new Promise((resolve, reject) => {
    reject({
      message: {
        code: errorCode,
        message: message
      }
    })
  })
}
